import React from 'react';
import { Link } from 'react-router-dom';
import { trackEvent } from '../analytics';
import './Footer.css';

function Footer() {
  const year = new Date().getFullYear();
  const handleNav = (target) => () => {
    trackEvent('nav_click', { target });
  };
  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="footer-inner">
        <div className="footer-copy">© {year} Tweedia</div>
        <nav className="footer-links" aria-label="Resources">
          <Link to="/pricing" onClick={handleNav('footer_pricing')}>Pricing</Link>
          <Link to="/guides/long-term-timelapse" onClick={handleNav('guide_long_term_timelapse')}>Timelapse Guide</Link>
          <Link to="/tools/timelapse-calculator" onClick={handleNav('timelapse_calculator')}>Timelapse Calculator</Link>
        </nav>
        <nav className="footer-links" aria-label="Legal">
          <Link to="/terms" onClick={handleNav('terms')}>Terms of Service</Link>
          <Link to="/privacy" onClick={handleNav('privacy')}>Privacy Policy</Link>
        </nav>
      </div>
    </footer>
  );
}

export default Footer;
